'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const ChatStoreContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== "production") ChatStoreContext.displayName = "ChatStoreContext";
export function useChatStoreContext(optional = false) {
  const context = React.useContext(ChatStoreContext);
  if (context == null && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: useChatStoreContext must be used within a <ChatProvider> component' : _formatErrorMessage(256));
  }
  return context;
}